import { render } from "./ExecutiveSearch.vue?vue&type=template&id=20bcfb9d&scoped=true&lang=html"
import script from "./ExecutiveSearch.vue?vue&type=script&lang=js"
export * from "./ExecutiveSearch.vue?vue&type=script&lang=js"

import "./ExecutiveSearch.vue?vue&type=style&index=0&id=20bcfb9d&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-20bcfb9d"

export default script